import { connect } from "react-redux"
import { Home } from "../../features"
import { initializeSession, initializeSessionFarms } from "../../redux/action/index.js"
import { useEffect } from "react"

const reduxState = (state) => ({
    verification: state.verification,
    session: state.session,
})

const reduxDispatch = (dispatch) => ({
    setInitializeSession: (data) => dispatch(initializeSession(data)),
    setInitializeSessionFarms: (data) => dispatch(initializeSessionFarms(data)),
})

const HomePage = (props) => {
    const { setInitializeSession, setInitializeSessionFarms } = props;

    useEffect(() => {
        const sessionSignin = localStorage.getItem('session_signin');
        const sessionFarms = localStorage.getItem('session_farms');

        if (sessionSignin) {
            setInitializeSession(JSON.parse(sessionSignin));
        }

        if (sessionFarms) {
            setInitializeSessionFarms(JSON.parse(sessionFarms));
        }
    }, [setInitializeSession, setInitializeSessionFarms]);

    return <Home {...props} />
}

export default connect(reduxState, reduxDispatch)(HomePage)
